import React from "react";
import {ScrollView, View} from "react-native";

import {TermsAndConditions} from "../terms";

export const TermsOfServiceScreen = () => {
    return (
        <>
            <ScrollView style={{paddingTop: 0}}>
                <View style={{alignItems: 'center'}}>
                    <View style={{maxWidth: 768}}>
                        <TermsAndConditions/>
                    </View>
                </View>
            </ScrollView>
        </>
    );
};